import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CyclopsHttp } from './app.http';

@Injectable({
  providedIn: 'root',
})
export class AumyeGatewayService {
  constructor(private cyclopsHttp: CyclopsHttp) {}
  getGatewayStatus(): Observable<any> {
    return this.cyclopsHttp.get('GetGateWayInfo');
  }
}
